module.exports = __webpack_public_path__ + "img/develop-bg.71396d4e.png";